<!--
    描述：新增、编辑菜单弹框等
    时间：2020-04-26
    Created by zwh
-->
<template>
    <div class="" style="border-top:1px solid #eee">
        <div class="">
            <el-form :model="objectForm" :rules="formRules" ref="objectForm" label-width="100px">
                <el-row>
                    <el-col :span="24">
                        1
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    components: {},
    props : {},
    data() {
        return {
            objectForm : {

            },
            formRules : {

            },
        }
    },
    created() {

    },
    computed: {

    },
    methods: {

    },
}
</script>